export default __webpack_public_path__ + "static/latitude-service-center-aa705ad9ee0c727bef4eb2e65732287a.webp";